<template>
    <div>
        <div class="table-layout">
            <el-table :data="auditRecList" border max-height="400" style="width: 100%">
                <el-table-column prop="auditTime" label="审核时间" width="180"></el-table-column>
                <el-table-column prop="auditorName" label="审核人" width="180"></el-table-column>
                <!--<el-table-column prop="auditorComLevel" label="审核机构级别" width="120"></el-table-column>-->
                <el-table-column prop="auditState" label="审核状态" width="150">
                    <template slot-scope="rows">
                        <el-tag type="success" style="background-color: transparent; border: none" v-if="rows.row.auditState === 1" close-transition>
                            <span>审核通过</span>
                        </el-tag>
                        <el-tag type="danger" style="background-color: transparent; border: none" v-if="rows.row.auditState === -1" close-transition>
                            <span>审核未通过</span>
                        </el-tag>
                        <el-tag type="danger" style="background-color: transparent; border: none" v-if="rows.row.auditState === 0" close-transition>未审核</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="auditDesc" label="审核意见"></el-table-column>
            </el-table>
        </div>
        <div class="block pagination-layout">
            <el-pagination background layout="total, sizes, prev, pager, next, jumper" v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import devcReqrApi from '../../api/devcReqr'

    import { getDefaultPageSizes } from '../../app.conf'

    export default {
        name: 'swb-device-require-audit-rec-list',
        desc: '设备请购单-审核记录列表',
        props: ['item', 'tableHeight'],
        data: function () {
            return {
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,

                auditRecList: []
            }
        },

        created: function () {
            this.pageSize = this.pageSizes.first();
            this.getAuditRecList();
        },
        methods: {
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getAuditRecList();
            },

            getAuditRecList: function (data) {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = {};
                filterItems.voucherId = self.item;
                postData.filterItems = filterItems;

                devcReqrApi.getDeviceRequireAuditRecList(postData, function (result) {
                    if(result.type === "info") {
                        self.auditRecList = result.data.rows;
                        self.totalCount = result.data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/retailer/DeviceRequireAuditRecList.vue